module.exports = __webpack_public_path__ + "assets/events_transportation_black.adfc03e9.svg";